<template>
    <div class="option-group">
        <span class="option-group__label">{{ label }}</span>
        <slot/>
        <span class="option-group__line"/>
    </div>
</template>

<script>
export default {
    name: 'app-option-group',
    inject: ['AppSelect'],
    props: {
        label: String
    }
}
</script>

<style lang="stylus" scoped>
    @import "../../../stylus/variables"
    .option-group
        .option-group__label
            color: $text-light-grey
            padding: 9px 0px 9px 20px
        .option-group__line
            height: 1px
            border-top: 1px solid $border-color
            margin: 9px 9px
    
    .select-menu ul .option-group:last-child .option-group__line
        display: none
</style>